import { IApplicationState } from '../../types/redux';
import { ENewReviewModalStep } from '../../types/newReview';

export const getNewReviewFormStep = (state: IApplicationState): ENewReviewModalStep => {
  return state.newReview.meta.step;
};
